import { defineStore } from 'pinia';

export const useWhatsappCallsStore = defineStore('whatsappCalls', {
  state: () => ({
    call: null,
    status: 'idle',
    accountId: null,
    conversation: null,
    connections: [],
    connectionId: null,
    connection: null,
    isIncoming: false,
    isStarting: false,
    isPerformingAction: false,
    isLoadingConnections: false,
    isRefreshingConnection: false,
    error: '',
    mediaError: '',
  }),

  getters: {
    isActive: state =>
      ['ringing', 'connecting', 'connected'].includes(state.status),
    isTerminal: state =>
      ['rejected', 'ended', 'failed', 'missed'].includes(state.status),
  },

  actions: {
    setCall(call) {
      this.call = call;
    },

    setAccountId(accountId) {
      this.accountId = accountId;
    },

    setConversation(conversation) {
      this.conversation = conversation;
    },

    setConnections(connections) {
      this.connections = connections;
    },

    setIncoming(isIncoming) {
      this.isIncoming = isIncoming;
    },

    setStatus(status) {
      this.status = status;
    },

    setConnection(connection) {
      this.connection = connection;
    },

    setConnectionId(connectionId) {
      this.connectionId = connectionId;
    },

    setError(error) {
      this.error = error;
    },

    setMediaError(error) {
      this.mediaError = error;
    },

    reset() {
      this.call = null;
      this.status = 'idle';
      this.accountId = null;
      this.conversation = null;
      this.connections = [];
      this.connectionId = null;
      this.connection = null;
      this.isIncoming = false;
      this.isStarting = false;
      this.isPerformingAction = false;
      this.isLoadingConnections = false;
      this.isRefreshingConnection = false;
      this.error = '';
      this.mediaError = '';
    },
  },
});
